import { Component, OnInit } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { Store } from '@ngrx/store';
import { AppState, PaymentReport } from '../../../../store';
import * as _ from 'lodash';

@Component({
  selector: 'app-donation-report',
  templateUrl: './donation-report.component.html',
  styleUrls: ['./donation-report.component.css']
})
export class DonationReportComponent extends ReportBase implements OnInit {

  report: PaymentReport;
  controls = [];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getDonationReportData');
  }

  updateControls() {
    this.controls = [
      { name: 'name', type: 'text', title: 'Name' },
      { name: 'gender', type: 'select', title: 'Gender', options: [{ text: 'Male', value: 'm' }, { text: 'Female', value: 'f' }] },
      { name: 'teamGroup', type: 'select', title: 'Team', options: this.getSearchOptions('teamGroup') },
      { name: 'feeName', type: 'select', title: 'Fee', options: this.getSearchOptions('feeName') }
    ];

    super.updateControls();
  }

  private getSearchOptions(field: string) {
    return _.uniq(this.report.list.map(l => l[field])).map(t => ({
      text: t, value: t
    }));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/donation-report/donation-report.component.ts